//import lozad from 'lozad';
import AOS from 'aos';
import 'readmore-js/readmore.min';
import 'slick-carousel';
import initSlick from './components/slick';
import lozad from 'lozad';

AOS.init({ once: true });

const observer = lozad('.lozad', {
    rootMargin: '10px 0px', // syntax similar to that of CSS Margin
    threshold: 0.1, // ratio of element convergence
    enableAutoReload: true // it will reload the new image when validating attributes changes
});
observer.observe();

if(document.querySelector('.burger-wrapper')) {
    document.querySelector('.burger-wrapper').addEventListener('click', function H() {
        let __this = this;

        __this.classList.toggle('open');
        document.querySelector('.mob-overlay').classList.toggle('show');
        document.querySelector('.main-nav').classList.toggle('show');
        document.querySelector('.page-body').classList.toggle('show');
    });
    document.querySelector('.mob-overlay').addEventListener('click', function H(el) {
        el.stopPropagation();
        if(el.target === this) {
            document.querySelector('.main-nav').classList.toggle('show');
            document.querySelector('.burger-wrapper').classList.toggle('open');
            document.querySelector('.mob-overlay').classList.toggle('show');
            document.querySelector('.page-body').classList.toggle('show');
        }
    });
}

$('.menu-item-has-children').on('click', function H(e) {
    if(e.target === this) {
        $(this).toggleClass('arr-sh');
        $(this).find('.sub-menu-prim').toggleClass('active');
    }
});

//open submenu level 2
$('.sub-menu_0 > .menu_sublist__item').on('click', function () {
    $(this).toggleClass('arr-sh');
    (this).find('.sub-menu_1').toggleClass('active');
});

$('.page-footer__title svg').on('click', function H() {
    $(this).toggleClass('active');
    $(this).parents('.js-foot-col').find('ul')
        .toggleClass('active');
});

if(document.querySelector('.pop-up-overlay')) {
    let jsPP = document.querySelectorAll('.js-pp');

    jsPP.forEach(function(e) {
        e.addEventListener('click', function H(el) {
            el.preventDefault();
            document.querySelector('.pop-up-overlay').classList.add('show');
            document.querySelector('.page-body').classList.add('show');
        });
    });

    document.querySelector('.js-pp-c').addEventListener('click', () => {
        document.querySelector('.pop-up-overlay').classList.remove('show');
        document.querySelector('.page-body').classList.remove('show');
    });

    document.querySelector('.popup').addEventListener('click', function H(e) {
        if(e.target === this) {
            document.querySelector('.pop-up-overlay').classList.remove('show');
            document.querySelector('.page-body').classList.remove('show');
        }
    });
}

jQuery(document).on('gform_confirmation_loaded', function(event, formId) {
    if(formId === 20) {
        document.querySelector('.js-pp-c').innerHTML = 'Close';
    }
});

/* begin readmore script */

function initReadMore() {
    $('.js-readmore').readmore({
        speed: 150,
        collapsedHeight: 295,
        moreLink: '<a class="read-more-link" href="#">Read more</a>',
        lessLink: '<a class="read-less-link" href="#">Read less</a>',
        embedCSS: false
    });
}

$(document).ready(function() {
    if(window.innerWidth < 769) {
        initReadMore();
    }
});

$(window).resize(function() {
    if(window.innerWidth < 769) {
        initReadMore();
    } else {
        $('.js-readmore').readmore('destroy');
    }
});
/* end readmore script */


/* begin deal details tabs */
$('.js-tablinks').click(function H() {
    let index = $(this).index();
    $(this).addClass('active');
    $('.js-tablinks.active').not($(this)).removeClass('active');
    $('.js-tabcontent').eq(index).addClass('active');
    $('.js-tabcontent.active').not($('.js-tabcontent').eq(index))
        .removeClass('active');
});
/* end deal details tabs */

/* init Slick */
document.addEventListener("DOMContentLoaded", () => {
    initSlick();
});

window.addEventListener('resize', () => {
    const slickMob = document.querySelector('.js-carousel-mob');
    if(!slickMob) return;
    if(window.innerWidth < 481
        && !slickMob.classList.contains('slick-initialized')) {
        initSlick();
    }
});
/* init Slick */


//плавная прокрутка к элементу

$(document).ready(function() {
    //пример ссылки
    //<a href="#value" class="flowing-scroll">перейти</a> пример ссылки

    $('.flowing-scroll').on('click', function H() {
        let el = $(this),
            dest = el.attr('href');
        let destId = dest.slice(dest.indexOf('#'));

        if(destId !== undefined && destId !== '' && $(destId).offset() !== undefined ) {
            $('html').animate(
                { scrollTop: $(destId).offset().top - 50 }, 1000 // speed
            );
        }
    });
});

//FAQ accordion
function setHeightBody(el) {
    el.each(function SH(index, item) {
        if($(item).hasClass('open')) {
            let elHeight = $(item).prop('scrollHeight');
            $(item).css('height', elHeight);
        } else {
            $(item).removeAttr('style');
        }
    });
}

$(document).ready(function() {
    const faqAccordion = $('.faq-accordion__item');

    faqAccordion.on('click', function C() {
        faqAccordion.not($(this)).removeClass('open');
        faqAccordion.not($(this)).find('.faq-accordion__body').removeClass('open');
        $(this).toggleClass('open');
        $(this).find('.faq-accordion__body').toggleClass('open');
        setHeightBody(faqAccordion.find('.faq-accordion__body'));
    });
});

/* begin Itinerary cards js */
let roadMapItem = document.querySelectorAll('.card-itinerary__dot');

function roadMapScroll(elem) {
    [ ...elem ].forEach(function H(e) {
        if(Math.round(window.innerHeight / 2) <= Math.round(e.getBoundingClientRect().y)) {
            e.classList.add('card-itinerary__dot--disabled');
        } else {
            e.classList.remove('card-itinerary__dot--disabled');
        }
    });
}

$(window).scroll(function() {
    roadMapScroll(roadMapItem);
});
/* end Itinerary cards js */

/* begin longevity-product change position for mobile */
function changePositionLongevityProduct() {
    let mainHeight = $('.longevity-product__main').height();
    let pictureHeight = $('.longevity-product__picture').height();
    if(window.innerWidth < 993 && !$('.longevity-product__slider').length) {
        $('.longevity-product__main').css('top', `${pictureHeight + 30}px`);
        $('.longevity-product__picture').css('top', `-${mainHeight + 35}px`);
    } else {
        $('.longevity-product__main').css('top', '');
        $('.longevity-product__picture').css('top', '');
    }
}

$(document).ready(function() {
    changePositionLongevityProduct();
});

$(window).resize(function() {
    changePositionLongevityProduct();
});
/* end longevity-product change position for mobile */
